<template>
  <of-dialog :title="formTitle" @onCancel="cancel" :width="width">
    <div slot="content">
      <el-form ref="form" label-width="120px" :model="dataForm">
        <el-form-item label="姓名：">
          <p>{{dataForm.Name}}</p>
        </el-form-item>
        <el-form-item label="讲座名称">
          <p>{{dataForm.TrainTitle}}</p>
        </el-form-item>
        <el-form-item label="培训时间">
          <p>{{StartTime(dataForm.LectureTime)}}</p>
        </el-form-item>
        <el-form-item label="账号类型：">
          <p>{{MemberType(dataForm.MemberType)}}</p>
        </el-form-item>
        <el-form-item label="人数：">
          <p>{{dataForm.SignUpNum}}</p>
        </el-form-item>
        <el-form-item label="手机号码：">
          <p>{{dataForm.Phone}}</p>
        </el-form-item>
        <el-form-item label="是否到场：">
          <p>{{IsAttended(dataForm.IsAttended)}}</p>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import { saveAs } from "file-saver";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null
    },
    formTitle: {
      type: String,
      default: ""
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isdisabled: false,
      width: "35%"
    };
  },
  mounted() {
    console.log(this.dataForm);
  },
  components: {
    OfDialog
  },
  computed: {
    Sex() {
      return data => {
        return data == 0 ? "女" : "男";
      };
    },
    StartTime() {
      return data => {
        return this.dateChange(data);
      };
    },
    IsAttended() {
      return data => {
        return data == 1 ? "是" : "否";
      };
    },
    MemberType() {
      return data => {
        return data == 1 ? '个人' : '团体';
      }
    }
  },
  methods: {
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    //时间戳转换
    dateChange(value) {
      var date = new Date(value * 1000);
      var y = date.getFullYear();
      var m =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var d = date.getDate();
      var h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var mm =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return y + "-" + m + "-" + d + " " + h + ":" + mm + ":" + s;
    }
  }
};
</script>


<style scoped>
.bg {
  background-color: #f2f2f2;
}
.el-form >>> .el-form-item {
  margin-bottom: 0;
}
.el-dialog__wrapper >>> .el-dialog .el-dialog__footer .el-button--primary {
  display: none;
}
</style>
